module.exports = __webpack_public_path__ + "static/assets/7999d4ecd7432b7b133b32111415f0df.svg";